import { Maybe, TemplateLayout as HygraphTemplateLayout } from '@/lib/types';
import { TemplateDetail as HygraphTemplateDetail } from '@/lib/types';

import { TemplateDetailRendererProps } from '@/components/template/template-renderer';

import { TemplateLayout } from '@/enums/template-layout';

export default function templateDetailTransformer(
  detail: Maybe<HygraphTemplateDetail>
): TemplateDetailRendererProps {
  const templateLayout =
    detail?.templateLayout ?? HygraphTemplateLayout.WithSidebar;

  return {
    layout: TemplateLayout[templateLayout],
    hero: detail?.hero,
    title: detail?.heading,
    author: detail?.author,
    estimatedReadingTime: detail?.estimatedReadingTime,
    publishedAt: detail?.published,
    modifiedAt: detail?.modified,
    tocEnabled: detail?.tocEnabled ?? false,
    seo: detail?.seo,
  };
}
